import Layout from 'components/layout';
import Heading from 'components/typography/heading';
import Text from 'components/typography/text';
import Cell from 'components/grid/cell';
import Grid from 'components/grid/grid';
import donateShareImg from 'images/shares/donate.png';

import btc from 'images/crypto/btc.svg';
import eth from 'images/crypto/eth.svg';
import matic from 'images/crypto/matic.svg';
import doge from 'images/crypto/doge.svg';
import uni from 'images/crypto/uni.svg';
import ltc from 'images/crypto/ltc.svg';
import bch from 'images/crypto/bch.svg';
import bat from 'images/crypto/bat.svg';
import link from 'images/crypto/link.svg';
import fil from 'images/crypto/fil.svg';
import xtz from 'images/crypto/xtz.svg';
import zec from 'images/crypto/zec.svg';

import { cryptoAddresses, centered, coinList } from './crypto.module.scss';

const ethAddress = '0x723787134E1fF64D27f4f2fCE57F706646664D77'; // same for anything on ETH blockchain

const Form = () => {
  return (
    <Layout
      title="Donate Bitcoin, Ethereum, or other coins to Resistbot"
      description="We accept BTC, ETH, DOGE, LTC, and more!"
      img={donateShareImg}
      imageAltText='Signs held at a protest reading "times up, real men respect women" and "womens rights are human rights" with overlay text that says "Text donate to 50409"'
    >
      <div>
        <Heading as="h1" className={centered} size="h2">
          The bot will keep running only if you chip&nbsp;in.
        </Heading>
        <Text className={centered}>
          Send us a few coins to keep the bot running!
        </Text>
      </div>
      <div className={cryptoAddresses}>
        <Grid>
          <Cell size={3}>
            <dl>
              <dt>
                <img src={btc} alt="Bitcoin" />
                Bitcoin
              </dt>
              <dd>
                <code>bc1qvdc558tyvjpd68aetcqkjcp5q024vnzg4u5eay</code>
              </dd>
              <dt>
                <img src={ltc} alt="Litecoin" />
                Litecoin
              </dt>
              <dd>
                <code>ltc1qj4mhwmek37e8r6ut2qfdazc5399xwm9gesp69f</code>
              </dd>
              <dt>
                <img src={doge} alt="Dogecoin" />
                Dogecoin
              </dt>
              <dd>
                <code>DBAxYQ8f36mg5wdYiNpMxuN4HZKnDEV7tj</code>
              </dd>
              <dt>
                <img src={bch} alt="BCH" />
                Bitcoin Cash
              </dt>
              <dd>
                <code>
                  bitcoincash:qr7s5hleu6gklh3zqav96q6h0dgqnq04kv09g8830m
                </code>
              </dd>
              <dt>
                <img src={fil} alt="FIL" />
                Filecoin
              </dt>
              <dd>
                <code>f1ha6nicrawifodbpeiisvoecfxeph2mrliotqxxi</code>
              </dd>
              <dt>
                <img src={zec} alt="ZEC" />
                Zcash
              </dt>
              <dd>
                <code>t1SrNxZyvdQZSaFocU4X9Na6jypuXxTAM7</code>
              </dd>
            </dl>
          </Cell>
          <Cell size={3}>
            <dl>
              <dt>
                <img src={eth} alt="Ethereum" />
                Ethereum
              </dt>
              <dd>
                <code>{ethAddress}</code>
              </dd>
              <dt>
                <img src={matic} alt="Matic" />
                Matic
              </dt>
              <dd>
                <code>{ethAddress}</code>
              </dd>
              <dt>
                <img src={link} alt="LINK" />
                Link
              </dt>
              <dd>
                <code>{ethAddress}</code>
              </dd>
              <dt>
                <img src={uni} alt="UNI" />
                Uniswap
              </dt>
              <dd>
                <code>{ethAddress}</code>
              </dd>
              <dt>
                <img src={bat} alt="BAT" />
                Basic Attention Token
              </dt>
              <dd>
                <code>{ethAddress}</code>
              </dd>
              <dt>
                <img src={xtz} alt="XTZ" />
                Tezos
              </dt>
              <dd>
                <code>tz2SUMJZqufsLppC92Ex4Bc6fHwm68CLr5SK</code>
              </dd>
            </dl>
          </Cell>
        </Grid>
      </div>
      <div>
        <Text className={coinList}>
          <p>
            In addition to the coins above we also accept the following at our
            Ethereum&nbsp;address:
          </p>
          <ul>
            <li>GUSD</li> <li>DAI</li> <li>OXT</li> <li>MKR</li> <li>MANA</li>{' '}
            <li>ENJ</li> <li>ZRX</li> <li>KNC</li> <li>STORJ</li> <li>BNT</li>{' '}
            <li>PAXG</li> <li>COMP</li> <li>AMP</li> <li>AAVE</li> <li>BAL</li>{' '}
            <li>CRV</li> <li>REN</li> <li>SNX</li> <li>UMA</li> <li>YFI</li>{' '}
            <li>1INCH</li> <li>SKL</li> <li>GRT</li> <li>LRC</li> <li>SAND</li>{' '}
            <li>CUBE</li> <li>LPT</li> <li>BOND</li> <li>INJ</li> <li>SUSHI</li>{' '}
            <li>MIR</li> <li>CTX</li> <li>ALCX</li> <li>ANKR</li> <li>FTM</li>
          </ul>
        </Text>
      </div>
    </Layout>
  );
};

export default Form;
